export default __webpack_public_path__ + "01a409e2db2e3ba6403767b23b81a025.png";